import "./MainExamStyle.css";
import { Outlet } from "react-router-dom";
import { ModalProvider } from "../../../contexts/ModalContext";
import Spinner from "../../../components/Shared/Spinner";
import Svgify from "@sumcode/svgify";
import { useState, useEffect, useRef } from "react";

import useExam from "../helpers/useExam";

const IFRSExamLayout = () => {
  const { examData, isLoading, currentQuestionIndex, totalQuestions } =
    useExam();

  // Timer: counts down from examData.duration (minutes), initialized once
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (!examData?.duration || initialized.current) return;
    initialized.current = true;
    setTimeLeft(examData.duration * 60);
  }, [examData?.duration]);

  useEffect(() => {
    if (timeLeft === null || timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev !== null && prev > 1 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  const formatTime = (secs: number) => {
    const h = Math.floor(secs / 3600);
    const m = Math.floor((secs % 3600) / 60);
    const s = secs % 60;
    return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
  };

  console.log("currentQuestionIndex", currentQuestionIndex);

  if (isLoading) return <Spinner />;

  return (
    <ModalProvider>
      <main className="ifrs-exam-container">
        <nav className="exam-header flex items-center justify-between gap-2">
          <h2>{examData?.title}</h2>

          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.2rem" }}>
            {timeLeft !== null && currentQuestionIndex !== -1 && (
              <div
                style={{
                  fontFamily: "monospace",
                  fontSize: "1rem",
                  fontWeight: 700,
                  background: timeLeft <= 300 ? "#fef2f2" : "#fff",
                  color: timeLeft <= 300 ? "#ef4444" : "#000",
                  padding: "0.3rem 0.75rem",
                  borderRadius: "6px",
                  letterSpacing: "0.1em",
                  minWidth: "90px",
                  textAlign: "center",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                  transition: "background 0.3s, color 0.3s",
                }}
              >
                {formatTime(timeLeft)}
              </div>
            )}

            {currentQuestionIndex !== -1 && (
              <p className="flex items-center gap-2">
                <Svgify IconName="screen" Scale={0.7} />
                <span>
                  {currentQuestionIndex + 1} of {totalQuestions}
                </span>
              </p>
            )}
          </div>
        </nav>

        <section className="exam-content">
          <Outlet />
        </section>
      </main>
    </ModalProvider>
  );
};

export default IFRSExamLayout;
